import { Field, useFormikContext } from 'formik';
import cloneDeep from 'lodash-es/cloneDeep';
import set from 'lodash-es/set';
import React from 'react';
import { WeightInput } from '@components';
import { StockTooltip } from '@components/common/StockTooltip';
import { ButtonClean, Checkbox, Input, Subsection } from '@fourthwall/components';
import { CompareAtPriceCheckboxField } from '../../components/CompareAtPriceCheckboxField';
import { ProductMembershipSettings } from '../../components/ProductMembershipSettings';
import { ProductVariantsData } from './components/ProductVariantsData';
import * as S from './styled';
export const VariantsView = ({ data, membershipTiers, viewConfig, onVariantTypeAdd, onStockChange, onIsCompareAtPriceEnabledValueChange, }) => {
    const { setFieldValue } = useFormikContext();
    if (!data?.length) {
        return null;
    }
    const handleSkuChange = (value) => {
        setFieldValue('variants', cloneDeep(data).map((variant) => set(variant, 'sku', value)));
    };
    const renderContent = () => {
        if (!viewConfig.showVariantsTable) {
            if (viewConfig.showManualStockNotice) {
                const hasQuantity = data.some(({ quantity }) => !!quantity);
                return React.createElement("p", null,
                    "In stock: ",
                    hasQuantity ? 'Manually set by Partner Manager' : 'Unlimited');
            }
            const firstVariantQuantity = data[0].quantity;
            return (React.createElement(S.SingleVariantContainer, null,
                React.createElement(S.SingleVariantItem, null,
                    React.createElement(S.SingleVariantLabel, null, "In stock:"),
                    React.createElement(StockTooltip, { quantity: firstVariantQuantity, disabled: !viewConfig.stockEditable, onChange: onStockChange(data[0].id) })),
                viewConfig.showExternalStock && (React.createElement(S.SingleVariantItem, null,
                    React.createElement(S.SingleVariantLabel, null, "In fulfillment center:"),
                    data[0].externalStock)),
                viewConfig.showWeight && (React.createElement(S.SingleVariantItem, null,
                    React.createElement(S.SingleVariantLabel, null, "Weight:"),
                    React.createElement(S.WeightInputWrapper, null,
                        React.createElement(WeightInput, { weightName: "variants[0].weight.value", unitName: "variants[0].weight.unit", size: "small", weightWidth: 80, unitWidth: 76, disabled: !viewConfig.editable }))))));
        }
        return (React.createElement(S.DataContainer, null,
            React.createElement(ProductVariantsData, { data: data, showWeight: viewConfig.showVariantsWeight, showPricing: viewConfig.showPricing, showExternalStock: viewConfig.showExternalStock, disabled: !viewConfig.editable, stockDisabled: !viewConfig.stockEditable, onStockTooltipChange: onStockChange })));
    };
    const renderAddVariantTypeButton = () => {
        if (!viewConfig.variantsEditable || !viewConfig.editable)
            return null;
        const label = viewConfig.showVariantsTable
            ? 'Edit, add or remove variants'
            : 'Add variants (different colors, sizes, etc.)';
        return React.createElement(ButtonClean, { label: label, onClick: onVariantTypeAdd });
    };
    return (React.createElement(S.Container, null,
        React.createElement(Subsection, { title: viewConfig.showVariantsTable ? 'Inventory and variants' : 'Inventory', borderless: viewConfig.showVariantsTable },
            renderContent(),
            renderAddVariantTypeButton(),
            React.createElement(S.Footer, null,
                viewConfig.showPricing && (React.createElement(CompareAtPriceCheckboxField, { onValueChange: onIsCompareAtPriceEnabledValueChange, disabled: !viewConfig.editable })),
                React.createElement(Field, { name: "isSoldOut", label: "Mark as sold out", component: Checkbox, disabled: !viewConfig.editable }),
                viewConfig.variantsEditable && (React.createElement(React.Fragment, null,
                    React.createElement(Field, { name: "visualHints.customSkus", component: Checkbox, label: viewConfig.showVariantsTable
                            ? 'Each variant has an identification code (such as a UPC or SKU #)'
                            : 'This product has an identification code (such as a UPC or SKU #)', disabled: !viewConfig.editable }),
                    viewConfig.showSingleSkuInput && (React.createElement(S.FooterInputContainer, null,
                        React.createElement(Field, { component: Input, name: "variants[0].sku", label: "SKU or UPC code", disabled: !viewConfig.editable, onValueChange: handleSkuChange }))))),
                React.createElement(ProductMembershipSettings, { membershipTiers: membershipTiers, disabled: !viewConfig.editable })))));
};
